import React from 'react';
import MajorSemesterSelection from '../../components/proStudent/MajorSemesterSelection/MajorSemesterSelection';

const MajorSelectionPage = () => {
  return (
    <div>
      <MajorSemesterSelection />
    </div>
  );
};

export default MajorSelectionPage;